import { Skeleton } from "@/components/ui/skeleton";

export function PageHeroSearchSkeleton() {
  return (
    <>
      <div className="py-6 sm:py-8 md:py-12">
        <div className="max-w-7xl mx-auto text-center space-y-2">
          <Skeleton className="h-9 w-48 mx-auto" />
          <Skeleton className="h-5 w-64 mx-auto" />
        </div>
      </div>

      <div className="py-2 -mx-4 px-4">
        <div className="max-w-2xl mx-auto">
          <Skeleton className="h-10 w-full rounded-xl" />
        </div>
      </div>
    </>
  );
}
